const emptyPanel = { data: [], total: 0, isLoading: false };

const getPanelState = (state, panelId) => state.analytics.panels[panelId] || emptyPanel;

export const getAnalyticsData = (state, panelId) => getPanelState(state, panelId).data;
export const getAnalyticsTotal = (state, panelId) => getPanelState(state, panelId).total;
export const getAnalyticsLoading = (state, panelId) => getPanelState(state, panelId).isLoading;
